import { Box, CircularProgress } from '@mui/material';
import { FC } from 'react';

type LoaderProps = {};

export const Loader: FC<LoaderProps> = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1
      }}
    >
      <CircularProgress />
    </Box>
  );
};
